import React, { useState, useEffect, useRef } from "react";
import {
  Col,
  Button,
  Modal,
  Spinner,
} from "react-bootstrap";

import {
  getSingleProjectById,
  downloadCancelForm,
} from "../../../../slices/thunk";
import { getAuthHeader } from "../../../../helpers/jwt-token-access/auth-token-header";
import { useSelector, useDispatch } from "react-redux";
import { useSearchParams } from "react-router-dom";
import AddContract from "../AddContract";
import SignatureCanvas from "react-signature-canvas";
import { jwtDecode } from "jwt-decode";

import { useTranslation } from "react-i18next";
import moment from "moment";
import CreateChangeOrderModal from "./createChangeOrder";
import { CallAPIPostPromise } from "Common/commaon";
import { getUserType } from "slices/userProfile/thunk";
import { AlertTriangle, CheckCircle2, Download, FileText, Mail, Pen, RefreshCw, Trash2 } from "lucide-react";
import { ContractLoadingModal } from "components/contractLoadingModal";
import { AlertDialog, AlertDialogAction, AlertDialogCancel, AlertDialogContent, AlertDialogDescription, AlertDialogFooter, AlertDialogHeader, AlertDialogTitle, AlertDialogTrigger } from "components/ui/alert-dialog";
import { Button as Button2} from "components/ui/button";
import DeletedContractHistoryDialog from "../deltedHistroy";
import api from "Common/api";
import { canAccessContractRecord, getContractSignerType, hasContractPermission, isHomeownerContractOwner } from "Common/permissions";
import { PERMISSIONS } from "Common/constants/permissions";
import { LoganProjectDraft } from "features/productAssistant/projectDraft";


interface ProjectDetailsProps {
  projectDetails: any;
  disable: any;
  setSuccessMsg:any;
  successmsg:any
  onCreateContractRequest?: (action: () => void) => void;
  editorOpen?: boolean;
  onEditorStateChange?: (open: boolean) => void;
  assistantSnapshot?: Partial<LoganProjectDraft>;
  onAssistantSnapshotChange?: (snapshot: Partial<LoganProjectDraft>) => void;
}
interface JwtPayload {
  userType: string;
}
const Contract: React.FC<ProjectDetailsProps> = ({
  projectDetails,
  disable,setSuccessMsg,successmsg,onCreateContractRequest,editorOpen = false,onEditorStateChange,assistantSnapshot,onAssistantSnapshotChange
}) => {
  const dispatch: any = useDispatch();
  const contractors = useSelector(
    (state: any) => state.Proposal.searchContractors
  );
  const { t } = useTranslation(); // ✅ React knows to update


  const token = localStorage.getItem("authUser");
  let decoded: any = "";
  if (token !== null) {
    decoded = jwtDecode<JwtPayload>(token);
  }

  let project: any = null;
  project = useSelector((state: any) => state.Contract.project);
 console.log(decoded,"pro")
  const [loading, setLoading] = useState<boolean>(false);
  const [signingStatus, setSigningStatus] = useState<"idle" | "submitting" | "refreshing">("idle");
  const [modal_change_order, setmodal_change_order] = useState(false);
  const [modal_sign_contract, setModal_sign_contract] = useState(false);
  const [modal_sign_change_order, setModal_sign_change_order] = useState(false);
  const [selectedCoId, setSelectedCoId] = useState(false);
  const [modal_view_change_order, setModal_view_change_order] = useState(false);
  const [newContractors, setNewContractors] = useState<any>([]);
const [deletedContract,setDeletedContract]=useState([])
const [resendLoading,setResendLoading] = useState(false)
const [deleteLoading,setDeleteLoading] = useState(false)
const [rightCancelLoading,setRightCancelLoading] = useState(false)
const [refresh,setRefresh]=useState(false)
  const sigCanvasRef = useRef<SignatureCanvas | null>(null);
console.log(project,"project")
  const clearSignature = () => {
    if (sigCanvasRef.current) {
      sigCanvasRef.current.clear();
      searchParam.delete("action");  // 💥 removes the “id” param
      setSearchParams(searchParam); // ✅ updates the URL
    }
  };
 
  useEffect(()=>{
    if(!project?.p_id){
      return
    }
   CallAPIPostPromise("/contract/get-deleted-hic-project",{
    projectId:project.p_id
   }).then((res:any)=>{
    console.log(res)
    setDeletedContract(res?.data||[])
   })
  },[project,refresh])


  useEffect(() => {
    if (successmsg ) {
      const timer = setTimeout(() => {
        setSuccessMsg(null);
      }, 5000);

      // Cleanup the timeout if the component unmounts or notification changes
      return () => clearTimeout(timer);
    }
  }, [successmsg]);



  const submitSignature = async () => {
    searchParam.delete("action");  // 💥 removes the “id” param
    setSearchParams(searchParam); // ✅ updates the URL
    const headers = getAuthHeader();
    if (!headers) {
      return;
    }
    if (sigCanvasRef.current && !sigCanvasRef.current.isEmpty()) {
      setLoading(true); // Set loading to true when submitting signature
      setSigningStatus("submitting");
      setModal_sign_contract(false);

      try {
        const signatureDataURL = sigCanvasRef.current.toDataURL();
        const signatureBlob = await fetch(signatureDataURL).then((res) =>
          res.blob()
        );
        const formData = new FormData();
        formData.append("file", signatureBlob, "signature.png");

        const response = await api.post(
          `/contract/sign-contract/${getContractSignerType(project)}/${project.p_id}`,
          formData,
          {
            headers: {
              ...headers,
              "Content-Type": "multipart/form-data",
            },
          }
        );
        if (response) {
          console.log('gg')

          setModal_sign_contract(false);
          if (project !== "") {
            setSigningStatus("refreshing");
            await dispatch(getSingleProjectById(project.p_id));
          }
          setSuccessMsg('Contract Signed Successfully');
        } else {
          console.error("Failed to upload signature");
        }
      } catch (error) {
        console.error("Error uploading signature:", error);
      } finally {
        setSigningStatus("idle");
        setLoading(false); // Set loading to false after submission completes
      }
    } else {
      alert("Please provide a signature first.");
    }
  };

  const submitChangeOrderSignature = async () => {
    const headers = getAuthHeader();
    if (!headers) {
      return;
    }
    if (sigCanvasRef.current && !sigCanvasRef.current.isEmpty()) {
      setLoading(true); // Set loading to true when submitting signature
      const signatureDataURL = sigCanvasRef.current.toDataURL();
      const signatureBlob = await fetch(signatureDataURL).then((res) =>
        res.blob()
      );
      const formData = new FormData();
      formData.append("file", signatureBlob, "signature.png");
      setModal_sign_change_order(false);

      try {
        const response = await api.post(
          `/contract/sign-change-order/${decoded.userType}/${selectedCoId}`,
          formData,
          {
            headers: {
              ...headers,
              "Content-Type": "multipart/form-data",
            },
          }
        );
        if (response) {
          if (project !== "") {
            setLoading(true);
            dispatch(getSingleProjectById(project.p_id)).finally(() =>
              setLoading(false)
            );
          }
          setSuccessMsg('Change Order Signed Successfully');
        } else {
          console.error("Failed to upload signature");
        }
      } catch (error) {
        console.error("Error uploading signature:", error);
      } finally {
        setLoading(false); // Set loading to false after submission completes
      }
    } else {
      alert("Please provide a signature first.");
    }
  };

  useEffect(() => {
    if (contractors.length) {
      const newData = contractors.map((item: any) => {
        return { label: item.name, value: item.id };
      });
      setNewContractors(newData);
    } 
  }, [contractors]);

  function openContractEditor() {
    onEditorStateChange?.(true);
  }
  function closeContractEditor() {
    onEditorStateChange?.(false);
  }
  function tog_change_order() {
    setmodal_change_order(!modal_change_order);
  }

  function tog_sign_contract() {
    
    setModal_sign_contract(!modal_sign_contract);
    console.log('ssd')
  }
  function tog_sign_change_order(id: any) {
    setSelectedCoId(id);
    setModal_sign_change_order(!modal_sign_change_order);
  }
  function tog_view_change_order() {
    setModal_view_change_order(!modal_view_change_order);
  }

  useEffect(() => {
    // Function to handle the click event
    const handleClickOutside = (event: MouseEvent) => {
      // Get the modal elements
      const backdropElement = document.getElementById("staticBackdrop");

      // Check if the click is outside the modal
      if (backdropElement && !backdropElement.contains(event.target as Node)) {
        // Close the modals if they are open
        if (modal_sign_contract) {
          console.log('gg')
          setModal_sign_contract(false);
        }
        if (modal_change_order) {
          setmodal_change_order(false);
        }
        if (modal_sign_change_order) {
          setModal_sign_change_order(false);
        }
        if (modal_view_change_order) {
          setModal_view_change_order(false);
        }
      }
    };

    // Attach the event listener
    document.addEventListener("mousedown", handleClickOutside);

    // Cleanup the event listener
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [
    modal_sign_contract,
    modal_change_order,
    modal_change_order,
    modal_view_change_order,
  ]);

  const handleCloseModel = (type: "created" | "draft") => {
    if (type) {
      closeContractEditor();
      setSuccessMsg(
        type === "draft"
          ? "Contract Draft Saved Successfully"
          : "Contract Created Successfully"
      );
    }
  };

  const downloadForm = (homeownerID:any) => {
    setRightCancelLoading(true);
    dispatch(downloadCancelForm(homeownerID,project?.p_id)).then((resp: any) => {
      if (resp) {
        window.open(resp.data[0].url, "_blank");
      }
    }).finally(() => {
      setRightCancelLoading(false);
    });
  };

  const [searchParam, setSearchParams] = useSearchParams();
const action =   searchParam.get('action') ||null
const tab =   searchParam.get('tab') ||null
console.log(modal_sign_contract)
  useEffect(()=>{
    console.log(action)
if((action === "sign" ) && project && !loading && tab ==="Homeowner-Contract" ){
  setModal_sign_contract(true);
  searchParam.delete("action");
  setSearchParams(searchParam);
}
  },[project,loading])
  const isContractor = decoded.userType === "contractor" || decoded.userType === "testContractor";
  const isHomeowner = isHomeownerContractOwner(project);
  
  const contractorSigned = !!project?.contract?.pc_contractor_signature_url?.trim();
  const homeownerSigned = !!project?.contract?.pc_homeowner_signature_url?.trim();
  
  const isSigned = isHomeowner
    ? homeownerSigned
    : isContractor && contractorSigned;
  
if(!project){
  return (
    <div className="tailwind-prefix space-y-4">
      <div className="flex flex-col md:flex-row md:items-start md:justify-between gap-3">
        <div className="space-y-2">
          <div className="h-8 w-64 rounded bg-gray-200 animate-pulse" />
          <div className="h-4 w-96 max-w-full rounded bg-gray-100 animate-pulse" />
        </div>
        <div className="h-10 w-44 rounded bg-gray-100 animate-pulse" />
      </div>
      <div className="grid grid-cols-1 md:grid-cols-3 gap-3">
        {[0, 1, 2].map((item) => (
          <div key={item} className="border border-gray-200 rounded-lg bg-white p-4">
            <div className="h-4 w-32 rounded bg-gray-100 animate-pulse" />
            <div className="mt-3 h-7 w-24 rounded bg-gray-200 animate-pulse" />
          </div>
        ))}
      </div>
      <div className="rounded-xl border border-gray-200 bg-white p-4 shadow-sm">
        <div className="space-y-3">
          <div className="h-5 w-40 rounded bg-gray-200 animate-pulse" />
          <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
            {[0, 1, 2, 3].map((item) => (
              <div key={item} className="h-4 rounded bg-gray-100 animate-pulse" />
            ))}
          </div>
          <div className="border-t border-gray-100 pt-4 flex flex-wrap gap-2">
            {[0, 1, 2].map((item) => (
              <div key={item} className="h-9 w-36 rounded bg-gray-200 animate-pulse" />
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}
const canEditContract = project?.contract?.pc_id
  ? canAccessContractRecord(project, PERMISSIONS.UPDATE_CONTRACT)
  : hasContractPermission(PERMISSIONS.CREATE_CONTRACT);
const canDeleteContract = canAccessContractRecord(project, PERMISSIONS.DELETE_CONTRACT);
const canSignAsContractor = canAccessContractRecord(project, PERMISSIONS.SIGN_CONTRACT);
const canManageChangeOrder = canAccessContractRecord(project, PERMISSIONS.UPDATE_CONTRACT);
const isHomeownerSigner = isHomeownerContractOwner(project);
const canSignContractAction = Boolean(project?.contract?.pc_id) && (canSignAsContractor || isHomeownerSigner);
const hasContractRecord = Boolean(project?.contract?.pc_id);
const hasContractDocument = Boolean(project?.contract?.pc_contract_url);
const contractStatusLabel = project?.p_status === "LIVE"
  ? "Live"
  : !project?.contract?.pc_id
  ? "Not Created"
  : !project?.contract?.pc_contract_url
  ? "Draft"
  : contractorSigned && homeownerSigned
  ? "Signed"
  : contractorSigned
  ? "Awaiting Homeowner"
  : homeownerSigned
  ? "Awaiting Contractor"
  : "Awaiting Signatures";
const statusBadgeClass = contractStatusLabel === "Live" || contractStatusLabel === "Signed"
  ? "contract-status-badge--success"
  : contractStatusLabel === "Not Created" || contractStatusLabel === "Draft"
  ? "contract-status-badge--neutral"
  : "contract-status-badge--pending";
  return (
    <React.Fragment>
    
     <div className="tailwind-prefix contract-document-step relative space-y-4">
{loading ? (
  <div className="absolute inset-0 z-10 flex items-start justify-center rounded-xl bg-white/60 pt-24 backdrop-blur-[1px]">
    <div className="inline-flex items-center gap-2 rounded-md border border-gray-200 bg-white px-4 py-2 text-sm font-medium text-gray-700 shadow-sm">
      <Spinner className="h-4 w-4" animation="border" role="status" />
      {t("Updating contract...")}
    </div>
  </div>
) : null}
<div className="flex flex-col md:flex-row md:items-start md:justify-between gap-3">
  <div>
  <div className="text-2xl font-[500] text-gray-900 mb-1">{t("Contract")}</div>
    <div className="text-sm text-gray-600">
      {t("Create, review, send, download, and sign the homeowner contract document.")}
    </div>
  </div>
  <DeletedContractHistoryDialog deletedContracts={deletedContract}/>
</div>

{canEditContract ? (
  <details className="contract-legal-notice rounded-lg border border-amber-200 bg-amber-50 p-4">
    <summary className="cursor-pointer text-sm font-medium text-amber-900 flex items-center gap-2">
      <AlertTriangle className="h-4 w-4" />
      {t("View important legal notice")}
    </summary>
    <p className="mt-3 text-sm text-amber-900 leading-relaxed">
      <b>{t("Thank you for using the Tradesmen’s, LLC.")}</b> {t("As a Contractor, it is incumbent upon you to ensure delivery of the Notice of Right to Cancellation of the contract to each owner of the property. Consumer protection laws require that the Contractor provide two (2) copies of the Notice of Right to Cancel to each home owner. If you do not hand deliver the Notice of Right to Cancellation to each of the homeowners that have signed the contract, you may not be able to recover in a court action, depending on your jurisdiction and your contract may not be valid. If you have sought asset protection through the Tradesmen’s, LLC you shall not be able to access asset protection as you are required to comply with all aspects of the requirements of having used the Tradesmen’s services AND complied with all consumer protection laws within your jurisdiction.")}
    </p>
  </details>
) : null}

<div className="contract-status-grid grid grid-cols-1 md:grid-cols-3 gap-3">
  <div className="contract-status-card border border-gray-200 rounded-lg bg-white">
    <div className="contract-status-card__label flex items-center gap-2 text-gray-500 text-sm">
      <FileText className="h-4 w-4" />
      {t("Contract Status")}
    </div>
    <div className={`contract-status-badge ${statusBadgeClass}`}>
      {t(contractStatusLabel)}
    </div>
  </div>
  <div className="contract-status-card border border-gray-200 rounded-lg bg-white">
    <div className="contract-status-card__label flex items-center gap-2 text-gray-500 text-sm">
      <CheckCircle2 className="h-4 w-4" />
      {t("Contractor")}
    </div>
    <div className={`contract-status-badge ${contractorSigned ? "contract-status-badge--success" : "contract-status-badge--pending"}`}>
      {contractorSigned ? t("Signed") : t("Signature Pending")}
    </div>
  </div>
  <div className="contract-status-card border border-gray-200 rounded-lg bg-white">
    <div className="contract-status-card__label flex items-center gap-2 text-gray-500 text-sm">
      <CheckCircle2 className="h-4 w-4" />
      {t("Homeowner")}
    </div>
    <div className={`contract-status-badge ${homeownerSigned ? "contract-status-badge--success" : "contract-status-badge--pending"}`}>
      {homeownerSigned ? t("Signed") : t("Signature Pending")}
    </div>
  </div>
</div>

{editorOpen ? (
  <section className="contract-inline-editor" aria-labelledby="contract-inline-editor-title">
    <div className="contract-inline-editor__header">
      <div>
        <h2 id="contract-inline-editor-title">{t(hasContractRecord ? "Review Homeowner Contract" : "Create Homeowner Contract")}</h2>
        <p>{t("Complete the required details below. Logan remains available on the right while you work.")}</p>
      </div>
      <button type="button" onClick={closeContractEditor} className="contract-inline-editor__close">
        {t("Close editor")}
      </button>
    </div>
    <AddContract
      assistantSnapshot={assistantSnapshot}
      onAssistantSnapshotChange={onAssistantSnapshotChange}
      afterCreate={() => {
        tog_sign_contract();
      }}
      closeModal={handleCloseModel}
    />
  </section>
) : (
<div className="contract-homeowner-card rounded-xl border border-gray-200 bg-white p-4 shadow-sm">
  <div className="flex flex-col lg:flex-row lg:items-start lg:justify-between gap-4 mb-4">
    <div className="min-w-0 flex-1">
      <h5 className="font-semibold text-base mb-1">{t("Client / Homeowner")}</h5>
      <div className="contract-homeowner-meta">
        <div className="contract-homeowner-meta__item"><span>{t("ID")}</span><strong>{project?.home_owner?.user_id || "-"}</strong></div>
        <div className="contract-homeowner-meta__item"><span>{t("Name")}</span><strong>{project?.home_owner?.user_first_name || "-"}</strong></div>
        <div className="contract-homeowner-meta__item"><span>{t("Phone")}</span><strong>{project?.home_owner?.user_phone || "-"}</strong></div>
        <div className="contract-homeowner-meta__item"><span>{t("Email")}</span><strong>{project?.home_owner?.user_email || "-"}</strong></div>
      </div>
    </div>
    <AlertDialog>
      {(canDeleteContract && project?.p_status !=="LIVE" &&project.contract?.pc_id ) && <AlertDialogTrigger asChild>
        <Button2 variant="destructive" className="w-full lg:w-auto flex-none">
          <Trash2 className="w-4 h-4 mr-2" />
          {t("Delete Contract")}
        </Button2>
      </AlertDialogTrigger>}
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>{t("Delete Contract?")}</AlertDialogTitle>
          <AlertDialogDescription>
            {t("This will move the contract to deleted history. You can view it later.")}
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel>{t("Cancel")}</AlertDialogCancel>
          <AlertDialogAction disabled={deleteLoading} onClick={()=>{
              setDeleteLoading(true);

            CallAPIPostPromise("/contract/delete-hic-project",{
              pc_id:project.contract?.pc_id ,
              deleted_by:decoded.userId,
              projectId:project.p_id
            }).then((res)=>{
              console.log(res)
              dispatch(getSingleProjectById(project.p_id)).finally(() =>
                setDeleteLoading(false)
              );
              setRefresh(r=>!r)
            }).catch((e)=>{
              console.log(e)
              setDeleteLoading(false)

            })
          }} bg={"#E71D07"} className="bg-red-600 hover:bg-red-700">
            {deleteLoading ? (
              <span className="inline-flex items-center gap-2">
                <Spinner className="h-4 w-4" animation="border" role="status" />
                {t("Deleting...")}
              </span>
            ) : t("Delete")}
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  </div>

  {!hasContractDocument && (
    <div className="border border-dashed border-gray-300 rounded-lg bg-gray-50 p-6 text-center mb-4">
      <div className="mx-auto mb-3 flex h-12 w-12 items-center justify-center rounded-lg bg-white border border-gray-200">
        <FileText className="h-6 w-6 text-gray-600" />
      </div>
      <div className="text-lg font-medium text-gray-900">{t("No contract document yet")}</div>
      <div className="text-sm text-gray-600 mt-1">
        {t("Create the contract before sending or collecting signatures.")}
      </div>
      {canEditContract && project?.p_status !== "LIVE" && !disable && !hasContractRecord ? (
        <button
          type="button"
          disabled={loading}
          onClick={() => onCreateContractRequest ? onCreateContractRequest(openContractEditor) : openContractEditor()}
          className="mt-4 inline-flex items-center justify-center border-0 px-4 py-[10px] rounded-md bg-[#2563EB] text-white hover:bg-[#1D4ED8] disabled:opacity-60 disabled:cursor-not-allowed transition text-[13px] font-medium"
        >
          <FileText className="h-4 w-4 mr-2" />
          {t("Create Contract")}
        </button>
      ) : null}
    </div>
  )}

  <div className="contract-document-actions border-t border-gray-100 pt-4">
    <div className="mb-2 text-sm font-medium text-gray-900">{t("Document Actions")}</div>
  <div className="grid grid-cols-1 sm:grid-cols-2 xl:flex xl:flex-wrap gap-2">
  {/* Contract Download (hidden for subcontractor) */}
  {decoded.userType !== "subcontractor" && project?.contract?.pc_contract_url && (
    <a
  href={project?.contract?.pc_contract_url}
  target="_blank"
  rel="noopener noreferrer"
  className="contract-action contract-action--secondary"
>
  <Download className="h-4 w-4 mr-1" /> {t("Download Contract")}
</a>

  )}

  {/* Resend Contract */}
  {hasContractDocument && canEditContract && (
    <button
      type="button"
      disabled={resendLoading || loading}
      onClick={() => {
        setResendLoading(true);
        CallAPIPostPromise("/contract/resend-contract", {
          projectId: project.p_id,
          userType: getUserType(),
        })
          .then(() => {
            setSuccessMsg('Email Successfully Sent');
          })
          .finally(() => setResendLoading(false));
      }}
      className="contract-action contract-action--secondary"
    >
      {resendLoading ? <RefreshCw className="h-4 w-4 mr-1 animate-spin" /> : <Mail className="h-4 w-4 mr-1" />}
      {resendLoading ? t("Sending...") : t("Send Contract")}
    </button>
  )}
   
  {/* Create / Update Contract or Change Order */}
  {canEditContract &&
    (project?.p_status !== "LIVE" ? (
      !disable &&
      (hasContractRecord ? (
        <button
        onClick={openContractEditor}
        disabled={loading}
        type="button"
        className="contract-action contract-action--secondary"
      >
          <Pen className="h-4 w-4 mr-1" />
          {t("Review/Edit")}
        </button>
      ) : null)
    ) : canManageChangeOrder ? (
      <button
      type="button"
        disabled={loading}
        onClick={tog_change_order}
      className="contract-action contract-action--primary"
      >
        {t("Create Change Order")}
      </button>
    ) : null)}


  {/* Sign Contract / View Change Orders */}
  {project.p_status !== "LIVE" ? (
    hasContractDocument && canSignContractAction && (
 
<button
  type="button"
  onClick={tog_sign_contract}
  disabled={isSigned || loading}
  className="contract-action contract-action--primary"
>
  <Pen className="h-4 w-4 mr-1" />
  {isSigned ? t("Signed") : t("Sign Contract")}
</button>

    )
  ) : (
    <button
    type="button"
      disabled={loading}
      onClick={tog_view_change_order}
      className="contract-action contract-action--primary"
    >
      {t("View Change Orders")}
    </button>
  )}

  {/* Download Right To Cancellation */}
  {["contractor", "testContractor"].includes(decoded.userType) && project?.contract?.pc_contract_url && (
	    <button
	    type="button"
      disabled={rightCancelLoading}
	      onClick={()=>{
	        downloadForm(project?.home_owner?.user_id)
	      }}
	      className="contract-action contract-action--secondary"
	    >
      {rightCancelLoading ? <Spinner className="h-4 w-4 mr-1" animation="border" role="status" /> : <Download className="h-4 w-4 mr-1" />}
	      {rightCancelLoading ? t("Downloading...") : t("Download Right To Cancel")}
	    </button>
  )}
</div>
  </div>

</div>
)}
     </div>
	    

      {/*Sign Contract Modal */}

      {/* <Modal
  size="sm"
  show={modal_sign_contract}
  onHide={() => {
    tog_sign_contract();
    searchParam.delete("action");  // 💥 removes the “id” param
    setSearchParams(searchParam); // ✅ updates the URL
  }}
  backdrop={"static"}
  id="staticBackdrop"
  centered
  data-bs-focus="false"
>
  <Modal.Header
    className="modal-title fw-bold"
    id="staticBackdropLabel"
    style={{ background: "rgb(249, 250, 251)" }}
  >
    {t("Sign Contract")}
  </Modal.Header>
  <Modal.Body
    className="p-5"
    style={{ background: "rgb(249, 250, 251)" }}
  >
    <SignatureCanvas
      ref={sigCanvasRef}
      penColor="black"
      canvasProps={{
        width: 200,
        height: 200,
        className: "sigCanvas",
        style: { backgroundColor: "white" },
      }}
    />
    <div className="d-flex mt-2 justify-content-between">
      <Button variant="primary" onClick={clearSignature}>
        {t("Clear")}
      </Button>
      <Button variant="primary" onClick={submitSignature}>
        {t("Submit")}
      </Button>
    </div>
  </Modal.Body>
</Modal> */}


      {/*Change Order Modal */}




      {/*Sign Contract Modal */}

      <Modal
  size="sm"
  show={modal_sign_change_order}
  onHide={() => {
    tog_sign_change_order(null);
  }}
  backdrop={"static"}
  id="staticBackdrop"
  className="tailwind-prefix"
  centered
  style={{
    zIndex:9000,

  }}
  data-bs-focus="false"
>

  <Modal.Body
    className="p-4 "
    
    style={{ backgroundColor:"white",width:500,}}
  >
            <div className="flex flex-col ">
            <div className="flex items-center justify-between pb-4 border-b">
            <div>
              <div className="text-xl font-semibold text-gray-900">
                Sign Change Order #{selectedCoId}
              </div>
              <p className="text-sm text-gray-500 mt-1">
                Please sign below to approve this change order
              </p>
            </div>
       
          </div>
          < div className="">
            <div className="border-2 border-dashed border-gray-300 rounded-lg p-4 bg-gray-50">
              <div className="flex items-center justify-between mb-3">
                <div className="flex items-center gap-2 text-sm text-gray-600">
                  <Pen className="h-4 w-4" />
                  <span>Draw your signature below</span>
                </div>
                <Button
                  variant="outline"
                  size="sm"
                  onClick={clearSignature}
                >
                  Clear
                </Button>
              </div>
    <SignatureCanvas
      ref={sigCanvasRef}
      penColor="black"
      canvasProps={{
        width: 600,
        height: 200,
        className: 'w-full bg-white border border-gray-200 rounded cursor-crosshair',
      }}
    />
                <p className="text-xs text-gray-500 mt-3">
              By signing this document, you acknowledge and agree to the terms outlined in Change Order {selectedCoId}.
            </p>
               {/* Footer */}
          <div className="flex items-center justify-end gap-3 pt-6 border-t">
            <Button variant="outline" onClick={()=>{
              tog_sign_change_order("")
            }}>
              Cancel
            </Button>
            <Button
              onClick={submitChangeOrderSignature}
              className="bg-blue-600 hover:bg-blue-700"
            >
              Sign & Continue
            </Button>
 </div>
 
      </div>
    </div>
    </div>
  </Modal.Body>
</Modal>


      {/*Change Orders */}

      <Modal
  size="lg"
  show={modal_view_change_order}
  onHide={tog_view_change_order}
  backdrop="static"
  centered
  data-bs-focus="false"
>
  <Modal.Header
    closeButton
    style={{ background: "rgb(249, 250, 251)" }}
    className="border-0 "
  >
    <Modal.Title className="fw-bold">{t("Change Orders ")}</Modal.Title>
  </Modal.Header>

  <Modal.Body className="p-4 tailwind-prefix" style={{ background: "rgb(249, 250, 251)" }}>
    <Col lg={12}>
      {project?.change_orders?.length > 0 ? (
        <div className="space-y-3">
          {project.change_orders.map((item: any) => {
            const createdAt = item?.co_created_at
              ? moment(item.co_created_at).format("DD/MM/YYYY")
              : "";

            const contractUrl = item?.co_contract_url?.trim();

            return (
              <div
                key={item.co_id}
                className="w-full rounded-xl border border-gray-200 bg-white shadow-sm p-4"
              >
                {/* Top Row */}
                <div className="flex items-start justify-between gap-3">
                  <div>
                    <div className="text-sm font-semibold text-gray-900">
                      {t("Change Order")} #{item.co_id}
                    </div>
                    <div className="text-xs text-gray-500 mt-1">
                      {t("Created")}: {createdAt || t("N/A")}
                    </div>
                  </div>

                  {/* Small status pill (optional) */}
                  <div className="px-2 py-1 text-xs rounded-full bg-gray-100 text-gray-700">
                    {t("Pending")}
                  </div>
                </div>

                {/* Action Buttons */}
                <div className="mt-4 flex flex-wrap gap-2">
                  {contractUrl ? (
                    <a
                      href={contractUrl}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="inline-flex items-center border-0 justify-center min-w-[140px] px-3 py-[9px] rounded-md
                                 bg-[#2563EB] text-white hover:bg-[#1D4ED8]
                                 transition text-[13px] font-medium"
                    >
                      <i className="ri-download-2-line mr-1"></i>
                      {t("Download")}
                    </a>
                  ) : (
                    <button
                      type="button"
                      disabled
                      className="inline-flex items-center  border-0 justify-center min-w-[140px] px-3 py-[9px] rounded-md
                                 bg-gray-200 text-gray-500 cursor-not-allowed text-[13px] font-medium"
                    >
                      {t("No Contract")}
                    </button>
                  )}

                  <button
                    type="button"
                    onClick={() => tog_sign_change_order(item.co_id)}
                    className="inline-flex items-center border-0 justify-center min-w-[140px] px-3 py-[9px] rounded-md
                               bg-[#2563EB] text-white hover:bg-[#1D4ED8]
                               transition text-[13px] font-medium"
                  >
                    {t("Sign")}
                  </button>

                  {/* <button
                    type="button"
                    className="inline-flex items-center border-0 justify-center min-w-[160px] px-3 py-[9px] rounded-md
                               bg-[#16A34A] text-white hover:bg-[#15803D]
                               transition text-[13px] font-medium"
                  >
                    {t("Submit Contract")}
                  </button> */}
                </div>
              </div>
            );
          })}
        </div>
      ) : (
        <div className="w-full rounded-xl border border-gray-200 bg-white p-5 text-center text-gray-500">
          {t("No Change Orders Available")}
        </div>
      )}
    </Col>
  </Modal.Body>
</Modal>
<CreateChangeOrderModal modal_change_order={modal_change_order} tog_change_order={tog_change_order} />
<Modal
  show={signingStatus !== "idle"}
  centered
  backdrop="static"
  keyboard={false}
  contentClassName="border-0 shadow-lg"
>
  <Modal.Body className="tailwind-prefix px-6 py-8 text-center">
    <div className="mx-auto mb-4 flex h-14 w-14 items-center justify-center rounded-full bg-blue-50">
      <Spinner animation="border" role="status" className="text-blue-600" />
    </div>
    <h3 className="mb-2 text-lg font-semibold text-gray-900">
      {t(signingStatus === "submitting" ? "Signing your contract" : "Finalizing your contract")}
    </h3>
    <p className="mb-0 text-sm text-gray-600">
      {t(
        signingStatus === "submitting"
          ? "Your signature is being securely submitted. Please do not close this window."
          : "Your signature was submitted. We are refreshing the signed contract details."
      )}
    </p>
  </Modal.Body>
</Modal>
<ContractLoadingModal title={"Contract Review and Signature"} pdfURL={project?.contract?.pc_contract_url } project={project} submitSignature={submitSignature}  sigCanvasRef={sigCanvasRef} onClose={()=>{
  setModal_sign_contract(false)
}} open={modal_sign_contract}/>
    </React.Fragment>
  );
};

export default Contract;
